<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            :dense="dense"
            :itemText="itemText"
            :disabled="disabled"
            :autoComplete="autoComplete"
            @change="$emit('change', $event)"
        />
        <sys-register-activity @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectActivity',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        itemText: {
            type: String,
            default: 'name'
        },
        clearable: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        disabled: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        brandId: {
            default: null
        }
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },

        brandId(val){
            this.getItems();
        },
    },
    methods: {
        ...mapActions('activity', ['ActionFindActivities']),        
        
        async getItems() {

            this.loading = true;
            let payload = {
                find_columns: {
                    active: 1
                },
                with: 'paymentEvent.periodicity,paymentEvent.valueType',
                filterByDepartament: true,
            };

            if(this.brandId){
                
                payload.filter_relations = [
                    {
                        name:   'brands',
                        key:    'brands.id', 
                        value:  this.brandId,
                        includeNull: true,
                    }
                ];
            }

            await this.ActionFindActivities(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>